export const CtrlToRotate = ({ fill = "#E3E5FA" }: { fill?: string }) => {
  return (
    <svg
      width="60"
      height="28"
      viewBox="0 0 60 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.5842 4C21.5754 4.00022 24.0003 6.42505 24.0005 9.41626V18.5837C24.0003 21.575 21.5754 23.9998 18.5842 24H9.41675C6.42553 23.9998 4.00071 21.575 4.00049 18.5837V9.41626C4.00071 6.42505 6.42553 4.00022 9.41675 4H18.5842ZM8.95654 12.2629C8.33169 12.263 7.80677 12.4791 7.38184 12.9124C7.19017 13.1082 7.03586 13.3422 6.91919 13.613C6.80682 13.8837 6.75073 14.1631 6.75073 14.4504C6.75079 14.7252 6.8049 14.9977 6.91309 15.2683C7.02559 15.535 7.18184 15.769 7.38184 15.969C7.80681 16.3855 8.34447 16.594 8.99438 16.594C9.2402 16.594 9.55279 16.5252 9.93188 16.3877V15.106C9.66529 15.3975 9.35066 15.5441 8.98828 15.5442C8.67578 15.5442 8.4173 15.4478 8.21313 15.2561C7.98827 15.0437 7.87513 14.7732 7.875 14.4443C7.875 14.0986 7.99601 13.8124 8.23755 13.5874C8.44172 13.4041 8.69245 13.3127 8.98828 13.3127C9.37148 13.3128 9.68611 13.4652 9.93188 13.7693V12.4753C9.58188 12.3337 9.25654 12.2629 8.95654 12.2629ZM10.3835 12.3313V13.2505H11.271V16.5H12.3525V13.2505H13.24V12.3313H10.3835ZM13.7185 12.3313V16.5H14.8V14.8997L15.8376 16.5H17.1816L15.8755 14.7935C16.1045 14.7476 16.2963 14.6523 16.4504 14.5066C16.6713 14.2941 16.7812 14.0041 16.7812 13.6375C16.7812 13.2541 16.6623 12.9416 16.4248 12.7C16.1874 12.4543 15.8481 12.3313 15.4067 12.3313H13.7185ZM17.637 12.3313V16.5H20.0186V15.5808H18.7185V12.3313H17.637ZM15.0063 13.1687C15.2437 13.1687 15.4168 13.2228 15.5251 13.3311C15.621 13.4186 15.6692 13.5356 15.6692 13.6814C15.6692 13.823 15.6229 13.9401 15.5312 14.0317C15.4146 14.144 15.2394 14.2002 15.0063 14.2002H14.8V13.1687H15.0063Z"
        fill={fill}
      />
      <path
        d="M26.962 15.038V13.47H29.146V11.286H30.854V13.47H33.038V15.038H30.854V17.222H29.146V15.038H26.962Z"
        fill="white"
      />
      <path
        d="M55.3332 11.6663V16.333C55.3332 21.4877 51.1545 25.6663 45.9998 25.6663C40.8452 25.6663 36.6665 21.4877 36.6665 16.333V10.4997C36.6665 5.98935 40.3228 2.33301 44.8332 2.33301H45.9998C51.1545 2.33301 55.3332 6.51168 55.3332 11.6663Z"
        stroke="#F6F7FD"
        stroke-width="2.1"
        stroke-linecap="round"
      />
      <path
        d="M45.9998 2.33301V9.79967C45.9998 10.1863 45.6865 10.4997 45.2998 10.4997H36.6665"
        stroke="#F6F7FD"
        stroke-width="2.1"
        stroke-linecap="round"
      />
    </svg>
  );
};
